import { Component } from '@angular/core';
import { Toast } from 'ngx-toastr';

// Reference: https://github.com/scttcper/ngx-toastr/blob/master/src/app/pink.toast.ts
@Component({
  selector: 'app-success-toastr',
  templateUrl: './success-toastr.component.html',
  styleUrl: './success-toastr.component.scss'
})

export class SuccessToastrComponent extends Toast {
  closeToast(): void {
    this.remove();
  }
}
